<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-img"><img alt="image" src="images/img35.jpg"/></p>
<p class="chap"><a id="ch16"></a>TOBACCO, 1620</p>
<p class="noindent"><span class="big">B</span>y 1615, Jamestown was almost defunct. Since 1607, the Virginia Company had invested $11 million (in today’s currency) in what was shaping up to be an organizational and institutional disaster. Two things helped turn the situation around.</p>
<p class="indent">First, the company gave up control of the colony’s property. Many of the settlers were either gentlemen seeking adventure and quick riches or poor people swept up off the streets of London or other English cities and forced onto company ships. Hard work was not something with which either groups were familiar. But once they owned their property, attitudes began to change and the settlers began to work–hard.</p>
<p class="indent">Second, the colony found a cash crop, <i>Nicotiana tabacum</i>, or sweet tobacco, from the Caribbean. Three years after John Rolfe sold his first shipment home in 1613, Virginia sent 20,000 pounds to feed the mother country’s growing addiction. Along with immense prosperity, the golden weed would also bring much sorrow: soil depletion, slavery, monocrop farming, and, of course, serious health problems. But Virginia had found its salvation; it never looked back. <span class="color">(10-009, 10-010)</span></p>
<p class="image"><img alt="image" src="images/img36.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter016.vue?25c885b7